import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'COMPANY',
    icon: 'menu-company',
    label: '合作商管理',
    remark: '维护公司信息、账户信息、开票信息',
    children: [
      {
        code: 'COMPANY_SUPPLIER',
        icon: 'menu-company-supplier',
        label: '车源供应商',
        remark: '提供车源',
        path: '/company/supplier',
      },
      {
        code: 'COMPANY_SELF',
        icon: 'menu-company-self',
        label: '自主公司',
        remark: '本方自主经营公司',
        path: '/company/self',
      },
      {
        code: 'COMPANY_WAREHOUSE',
        icon: 'menu-company-warehouse',
        label: '仓储公司',
        remark: '提供仓库',
        path: '/company/warehouse',
      },
      {
        code: 'COMPANY_CUSTOMS',
        icon: 'menu-company-customs',
        label: '报关公司',
        remark: '申报报关单',
        path: '/company/customs',
      },
      {
        code: 'COMPANY_PURCHASER',
        icon: 'menu-company-purchaser',
        label: '采购公司',
        remark: '买车的公司',
        path: '/company/purchaser',
      },
      {
        code: 'COMPANY_DOMESTIC_PARTNER',
        icon: 'menu-company-channel',
        label: '内贸合作公司',
        remark: '内贸采购、销售合同合作方',
        path: '/company/domestic-partner',
      },
      {
        code: 'COMPANY_CHANNEL',
        icon: 'menu-company-channel',
        label: '通道公司',
        remark: '提供外贸出口资质',
        path: '/company/channel',
      },
      {
        code: 'COMPANY_LOGISTICS',
        icon: 'menu-company-logistics',
        label: '承运公司',
        path: '/company/logistics',
      },
      {
        code: 'COMPANY_GUARANTEE',
        icon: 'menu-company-guarantee',
        label: '担保公司',
        remark: '做垫资业务',
        path: '/company/guarantee',
      },
      {
        code: 'COMPANY_DELIVERY',
        icon: 'menu-company-delivery',
        label: '交车公司',
        remark: '用于入库单',
        path: '/company/delivery',
      },
      {
        code: 'COMPANY_PICKUP',
        icon: 'menu-company-pickup',
        label: '提货公司',
        remark: '用于出库单',
        path: '/company/pickup',
      },
    ],
  },
] satisfies Menu[];
